import * as React from 'react'
import { News as NewsType, NewsWidgetCard, WidgetCardBaseProps } from "../../../../types"
import NewsItem from '../../Messenger/News/NewsItem'
import { NewsCenterController as MessengerNewsCenterController } from '../../../controllers'
import MobilityHelper from '../../../../helpers/MobilityHelper'
import { NewsController } from '../../../../controllers'

type IProps = WidgetCardBaseProps & {
  card: NewsWidgetCard
  admin?: boolean
}

interface IState {
  news: NewsType | null
}

const News = (props: IProps) => {
  const { widget, admin, locale } = props
  const [state, setState] = React.useState<IState>({
    news: null
  })
  const { news } = state

  const fetchLatestNews = async () => {
    try {
      let news: NewsType = null
      if (admin) {
        const { news: adminNews } = await NewsController.getNews(widget.news_center_id, { page: 1 })
        news = adminNews[0] || null
      } else {
        const { news: messengerNews } = await MessengerNewsCenterController.getNews({
          page: 1,
          per_page: 1,
        })
        news = messengerNews[0] || null
      }

      setState({ ...state, news: news, })
    } catch (ex) {
      console.error(ex)
    }
  }

  React.useEffect(() => {
    if (!widget.news_center_id) return

    fetchLatestNews().catch(console.error)
  }, [])

  if (!news || !Boolean(MobilityHelper.getTranslation(locale, news.translations, 'title'))) return null

  return (
    <NewsItem
      news={news}
      locale={locale}
    />
  )
}

export default News